<template>
  <AddSlider />
</template>
<script>
import AddSlider from '../../../components/skillup/firstSlider/AddSlider.vue'
import appConfig from '../../../app.config.json'

export default {
  page: {
    title: 'اضافه کردن اسلایدر',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'skillup-add-slider',
  components: { AddSlider },
}
</script>
